import * as i from 'icepick'
import { keyBy } from 'lodash'
import { IRecording } from './types'

export interface IRecordingsState {
  byId: {
    [contactId: string]: {
      loading: boolean
      error: any
      data: IRecording
    }
  }
  list: {
    [cacheKey: string]: {
      loading: boolean
      error?: any
      data?: {
        results: string[]
        totalPages: number
        totalResults: number
        page: number
        limit: number
      }
    }
  }
}

const initialState: IRecordingsState = {
  byId: {},
  list: {},
}

export const recordingsReducer = (
  state: IRecordingsState = initialState,
  action
): IRecordingsState => {
  switch (action.type) {
    case 'RECORDINGS/GET_RECORDING_PENDING':
      return i.assocIn(state, ['byId', action.meta.recordingId, 'loading'], true)
    case 'RECORDINGS/GET_RECORDING_REJECTED':
      return i
        .chain(state)
        .assocIn(['byId', action.meta.recordingId, 'loading'], false)
        .assocIn(['byId', action.meta.recordingId, 'error'], action.payload.data)
        .value()
    case 'RECORDINGS/GET_RECORDING_FULFILLED':
      return i
        .chain(state)
        .assocIn(['byId', action.meta.recordingId, 'loading'], false)
        .assocIn(['byId', action.meta.recordingId, 'data'], action.payload.data)
        .value()

    case 'RECORDINGS/LIST_RECORDINGS_PENDING':
      return i.assocIn(state, ['list', action.meta.cacheKey, 'loading'], true)
    case 'RECORDINGS/LIST_RECORDINGS_REJECTED':
      return i.assocIn(state, ['list', action.meta.cacheKey], {
        error: action.payload.data,
        loading: false,
      })
    case 'RECORDINGS/LIST_RECORDINGS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['list', action.meta.cacheKey, 'data'], {
          totalPages: Math.ceil(action.payload.headers['x-total-count'] / 20) || 1,
          totalResults: parseInt(action.payload.headers['x-total-count'], 10),
          page: action.meta.page,
          limit: action.meta.limit,
          results: action.payload.data.map(contact => contact.id),
        })
        .assocIn(['list', action.meta.cacheKey, 'loading'], false)
        .updateIn(['byId'], contacts => ({
          ...contacts,
          ...keyBy(
            action.payload.data.map(data => ({ data })),
            'data.id'
          ),
        }))
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/features/Recordings/Recordings.reducer.ts